import OrganizationEvents, { getStaticProps, getStaticPaths } from './[page]';

// getStaticProps fetches 0 offset when missing page param
export { getStaticProps, getStaticPaths };

export default OrganizationEvents;
